'use strict';

(function () {
    'use strict';

    toCompassFilter.$inject = ['measurementsService'];
    toBeaufortFilter.$inject = ['measurementsService'];
    toDirectionFilter.$inject = ['measurementsService'];
    angular.module('app.iot', ['app.services', 'ui.select', 'nvd3', 'download', 'angularjs.daterangepicker', 'ui-leaflet']);

    angular.module('app.iot').filter('toCompass', toCompassFilter).filter('toBeaufort', toBeaufortFilter).filter('toDirection', toDirectionFilter);

    /**
     * 
     * @param {*} measurementsService 
     */
    function toDirectionFilter(measurementsService) {
        'ngInject';

        return function (input) {
            return measurementsService.toDirection(input);
        };
    }

    /**
     * 
     * @param {*} measurementsService 
     */
    function toBeaufortFilter(measurementsService) {
        'ngInject';

        return function (input) {
            var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            return measurementsService.toBeaufort(input, closed);
        };
    }

    /**
     * 
     * @param {*} measurementsService 
     */
    function toCompassFilter(measurementsService) {
        'ngInject';

        return function (input, directions, defaultValue) {
            return measurementsService.toCompass(input, directions, defaultValue);
        };
    }
})();